import {
  LeadFormFieldType,
  type LeadFormFieldDto,
} from '@up2stay/up2promo-api-client';

type LeadFormFieldLabels = Record<string, string> | undefined;

/**
 * Fixed lead-form field definitions used when saving template content
 * and building the live phone preview.
 */
export function buildTemplateDetailFixedLeadFields(
  fieldLabels: LeadFormFieldLabels,
): LeadFormFieldDto[] {
  const labels = fieldLabels ?? {};
  const label = (key: string, fallback: string) => labels[key] ?? fallback;
  return [
    {
      type: LeadFormFieldType.FIRST_NAME,
      label: label('firstName', 'First name'),
      required: true,
      order: 0,
    },
    {
      type: LeadFormFieldType.LAST_NAME,
      label: label('lastName', 'Last name'),
      required: false,
      order: 1,
    },
    {
      type: LeadFormFieldType.PHONE,
      label: label('phone', 'Phone'),
      required: true,
      order: 2,
    },
    {
      type: LeadFormFieldType.EMAIL,
      label: label('email', 'Email'),
      required: true,
      order: 3,
    },
    {
      type: LeadFormFieldType.COMPANY,
      label: label('workspace', 'Company'),
      required: false,
      order: 4,
    },
    {
      type: LeadFormFieldType.JOB_TITLE,
      label: label('jobTitle', 'Job title'),
      required: false,
      order: 5,
    },
  ];
}
